import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import TrustCenterPolicyPreviewPage from '@/pages/trust-center/public/TrustCenterPolicyPreviewPage'

const searchSchema = z.object({
  token: z.string().optional(),
  email: z.string().optional(),
})

export const Route = createFileRoute('/trust/resources/$resourceId')({
  validateSearch: searchSchema,
  component: TrustCenterPolicyPreviewPage,
})
